module.exports = __webpack_public_path__ + "img/logo.31db1e5a.png";